/**
 * Whether the web shows the dated sign-in requirements (docs/PLAN-signin-requirements-20261029.md, "Rollout and
 * levers"): the countdown in the banner band and, on Team & Roles, each member's sign-in pill, the summary card and
 * the "help sign in" dialog. The one lever: `REACT_APP_SIGNIN_REQUIREMENTS`, a list of workspace ids where `*` admits
 * every resolved workspace. Off when absent; deploy.yml ships it as `*` (`vars.SIGNIN_REQUIREMENTS` narrows it or,
 * naming no workspace, turns it off).
 *
 * Portal Controls' "require two-step sign-in" card is not behind it: it is the owner's own setting, and hiding it would
 * only hide a requirement they set. The server decides everything whatever this says (ops/accountSecurity): hiding the
 * countdown hides where people read it, never the requirement or its date.
 */
import { buildEnv } from '../../config/buildEnv';

export const SIGNIN_REQUIREMENTS_ENV = 'REACT_APP_SIGNIN_REQUIREMENTS';

export function signInRequirementsShow(
  accountId: string | null | undefined,
  env: Record<string, string | undefined> = buildEnv(),
): boolean {
  const account = String(accountId ?? '').trim();
  if (!account) return false;
  const listed = String(env[SIGNIN_REQUIREMENTS_ENV] ?? '').split(',').map((s) => s.trim());
  return listed.includes('*') || listed.includes(account);
}
